@if (contactStations$ | async; as contacts) {
  <p>{{'service_intro' | translate}}</p>

  <select class="select-contact-type" (change)="onSelectContactCategory($event)">
    @for(contactCategory of contactCategories(); track contactCategory.id) {
      <option [value]="contactCategory.id">{{contactCategory.title[translate.getCurrentLang()]}}</option>
    }
  </select>

  @if (displayType === 'map') {
    <app-google-map class="google-map"
      [contacts]="filteredContacts()"
      [selected]="selected()"
      (selectContact)="setSelectedContact($event)" />
  }

  @if (selectedCategoryStation().textshort?.[translate.getCurrentLang()]; as text) {
    <p [innerHTML]="text"></p>
  }

  <h2>{{'selected_service' | translate}}</h2>
  @if (selected(); as contact) {
    <app-contact-detail [contact]="contact"></app-contact-detail>
  } @else {
    {{'service_not_selected' | translate}}
  }

  @let filtered = filteredContacts();
  @if (filtered?.length > 0) {
    <h2>{{'other_service' | translate}}</h2>
  }
  @for (contact of filteredContacts(); track contact.id) {

    @if (contact.id !== selected()?.id) {
      <app-contact-detail [contact]="contact"></app-contact-detail>
    }
  }
}
